import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';
export function TermsRestaurantsPage() {
  return <div className="min-h-screen bg-[#0B0B0B] text-white selection:bg-[#006847] selection:text-white" data-id="element-8185">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-[#0B0B0B]/80 backdrop-blur-md border-b border-white/10" data-id="element-8186">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-8187">
          <Link to="/" className="flex items-center gap-2 text-white/60 hover:text-white transition-colors text-sm font-medium" data-id="element-8188">
            <ArrowLeft className="w-4 h-4" data-id="element-8189" />
            Volver
          </Link>
          <div className="font-black text-xl tracking-tight" data-id="element-8190">NOIZA</div>
          <div className="w-20" data-id="element-8191" /> {/* Spacer for centering */}
        </div>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12 md:py-20" data-id="element-8192">
        <div className="mb-12" data-id="element-8193">
          <div className="w-12 h-12 bg-white/5 rounded-2xl flex items-center justify-center mb-6 border border-white/10" data-id="element-8194">
            <FileText className="w-6 h-6 text-white/80" data-id="element-8195" />
          </div>
          <h1 className="text-3xl md:text-4xl font-black mb-4 tracking-tight" data-id="element-8196">
            Términos y Condiciones para Restaurantes
          </h1>
          <p className="text-white/60 text-lg" data-id="element-8197">
            NOIZA – Plataforma Tecnológica y Marketplace Gastronómico
          </p>
        </div>

        <div className="space-y-12 text-white/80 leading-relaxed" data-id="element-8198">
          <section data-id="element-8199">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8200">
              <span className="text-[#006847]" data-id="element-8201">1.</span>
              INTRODUCCIÓN Y ACEPTACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8202">
              <p data-id="element-8203">
                Los presentes Términos y Condiciones regulan el acceso, uso y
                permanencia del restaurante dentro de la plataforma NOIZA, en
                adelante "la Plataforma".
              </p>
              <p data-id="element-8204">
                Al registrarse, acceder o utilizar cualquier funcionalidad de
                NOIZA, el restaurante declara:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8205">
                <li data-id="element-8206">Haber leído íntegramente este documento</li>
                <li data-id="element-8207">Comprender su contenido en su totalidad</li>
                <li data-id="element-8208">
                  Aceptar voluntaria e irrevocablemente todas sus condiciones
                </li>
              </ul>
              <p data-id="element-8209">
                En caso de no estar de acuerdo con alguno de los puntos
                establecidos, el restaurante deberá abstenerse de utilizar la
                Plataforma.
              </p>
            </div>
          </section>

          <section data-id="element-8210">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8211">
              <span className="text-[#006847]" data-id="element-8212">2.</span>
              NATURALEZA DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8213">
              <p data-id="element-8214">NOIZA es una solución tecnológica que combina:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8215">
                <li data-id="element-8216">Software como servicio (SaaS)</li>
                <li data-id="element-8217">Marketplace digital gastronómico</li>
                <li data-id="element-8218">Herramientas de gestión operativa para restaurantes</li>
              </ul>
              <p data-id="element-8219">La Plataforma permite a los restaurantes:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8220">
                <li data-id="element-8221">Mostrar su menú digital</li>
                <li data-id="element-8222">Recibir pedidos de clientes</li>
                <li data-id="element-8223">Gestionar su operación interna</li>
                <li data-id="element-8224">
                  Facilitar la comunicación directa con el cliente
                  (principalmente vía WhatsApp)
                </li>
              </ul>
              <p className="font-medium text-white" data-id="element-8225">
                NOIZA actúa únicamente como un facilitador tecnológico.
              </p>
            </div>
          </section>

          <section data-id="element-8226">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8227">
              <span className="text-[#006847]" data-id="element-8228">3.</span>
              DECLARACIÓN EXPRESA DE NO INTERMEDIACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8229">
              <p data-id="element-8230">El restaurante reconoce expresamente que NOIZA:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8231">
                <li data-id="element-8232">No es proveedor de alimentos</li>
                <li data-id="element-8233">No participa en la preparación de productos</li>
                <li data-id="element-8234">No manipula alimentos en ningún momento</li>
                <li data-id="element-8235">No realiza entregas ni logística</li>
                <li data-id="element-8236">No procesa pagos en nombre del restaurante</li>
                <li data-id="element-8237">No actúa como representante comercial del restaurante</li>
              </ul>
              <p data-id="element-8238">
                La Plataforma se limita a proporcionar herramientas digitales
                para facilitar la interacción entre el restaurante y el cliente
                final.
              </p>
            </div>
          </section>

          <section data-id="element-8239">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8240">
              <span className="text-[#006847]" data-id="element-8241">4.</span>
              INDEPENDENCIA DEL RESTAURANTE
            </h2>
            <div className="space-y-4" data-id="element-8242">
              <p data-id="element-8243">
                Cada restaurante que utiliza NOIZA opera como una entidad
                completamente independiente.
              </p>
              <p data-id="element-8244">Esto implica que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8245">
                <li data-id="element-8246">El restaurante es el único responsable de su operación</li>
                <li data-id="element-8247">
                  No existe relación laboral, societaria o de representación con
                  NOIZA
                </li>
                <li data-id="element-8248">
                  NOIZA no ejerce control sobre las decisiones del restaurante
                </li>
              </ul>
              <p data-id="element-8249">El restaurante mantiene total autonomía en:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8250">
                <li data-id="element-8251">Precios</li>
                <li data-id="element-8252">Menú</li>
                <li data-id="element-8253">Horarios</li>
                <li data-id="element-8254">Métodos de pago</li>
                <li data-id="element-8255">Procesos internos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8256">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8257">
              <span className="text-[#006847]" data-id="element-8258">5.</span>
              EXCLUSIÓN TOTAL DE RESPONSABILIDAD
            </h2>

            <div className="space-y-8" data-id="element-8259">
              <div data-id="element-8260">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8261">
                  5.1. Alcance general
                </h3>
                <p data-id="element-8262">
                  El restaurante acepta que NOIZA queda exento de cualquier tipo
                  de responsabilidad, directa o indirecta, derivada de la
                  operación del restaurante.
                </p>
              </div>

              <div data-id="element-8263">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8264">
                  5.2. Alimentos y calidad del servicio
                </h3>
                <p className="mb-2" data-id="element-8265">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8266">
                  <li data-id="element-8267">Calidad de los alimentos</li>
                  <li data-id="element-8268">Estado, frescura o preparación</li>
                  <li data-id="element-8269">Ingredientes utilizados</li>
                  <li data-id="element-8270">Contaminación cruzada</li>
                  <li data-id="element-8271">Problemas de higiene o salubridad</li>
                  <li data-id="element-8272">Reacciones alérgicas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8273">
                  Toda responsabilidad recae exclusivamente en el restaurante.
                </p>
              </div>

              <div data-id="element-8274">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8275">
                  5.3. Entregas y logística
                </h3>
                <p className="mb-2" data-id="element-8276">
                  NOIZA no participa ni interviene en la entrega de pedidos. Por
                  lo tanto, NOIZA no será responsable por:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8277">
                  <li data-id="element-8278">Retrasos en la entrega</li>
                  <li data-id="element-8279">Pérdida de pedidos</li>
                  <li data-id="element-8280">Entregas incompletas</li>
                  <li data-id="element-8281">Errores en dirección</li>
                  <li data-id="element-8282">Conducta de repartidores</li>
                  <li data-id="element-8283">Daños durante el transporte</li>
                </ul>
              </div>

              <div data-id="element-8284">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8285">
                  5.4. Pagos
                </h3>
                <p className="mb-2" data-id="element-8286">
                  NOIZA no procesa ni administra pagos. El restaurante es el
                  único responsable de:
                </p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-4" data-id="element-8287">
                  <li data-id="element-8288">Recepción de pagos</li>
                  <li data-id="element-8289">Validación de transferencias (incluyendo SINPE)</li>
                  <li data-id="element-8290">Manejo de efectivo</li>
                  <li data-id="element-8291">Confirmación de pagos</li>
                  <li data-id="element-8292">Prevención de fraudes</li>
                </ul>
                <p className="mb-2" data-id="element-8293">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8294">
                  <li data-id="element-8295">Pagos no recibidos</li>
                  <li data-id="element-8296">Comprobantes falsos</li>
                  <li data-id="element-8297">Errores en montos</li>
                  <li data-id="element-8298">Estafas o fraudes de terceros</li>
                </ul>
              </div>

              <div data-id="element-8299">
                <h3 className="text-lg font-semibold text-white mb-2" data-id="element-8300">
                  5.5. Relación con clientes
                </h3>
                <p className="mb-2" data-id="element-8301">NOIZA no será responsable por:</p>
                <ul className="list-disc pl-6 space-y-1 text-white/70 mb-2" data-id="element-8302">
                  <li data-id="element-8303">Reclamos de clientes</li>
                  <li data-id="element-8304">Reembolsos</li>
                  <li data-id="element-8305">Cancelaciones</li>
                  <li data-id="element-8306">Disputas</li>
                  <li data-id="element-8307">Opiniones o reseñas</li>
                </ul>
                <p className="font-medium text-white" data-id="element-8308">
                  Toda relación comercial se da directamente entre el
                  restaurante y el cliente.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-8309">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8310">
              <span className="text-[#006847]" data-id="element-8311">6.</span>
              USO DE LA PLATAFORMA
            </h2>
            <div className="space-y-4" data-id="element-8312">
              <p data-id="element-8313">El restaurante se compromete a utilizar NOIZA de forma:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8314">
                <li data-id="element-8315">Responsable</li>
                <li data-id="element-8316">Legal</li>
                <li data-id="element-8317">Transparente</li>
              </ul>
              <p className="mt-4" data-id="element-8318">Queda prohibido:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8319">
                <li data-id="element-8320">Publicar información falsa</li>
                <li data-id="element-8321">Manipular precios de forma engañosa</li>
                <li data-id="element-8322">Simular disponibilidad inexistente</li>
                <li data-id="element-8323">Utilizar la plataforma con fines fraudulentos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8324">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8325">
              <span className="text-[#006847]" data-id="element-8326">7.</span>
              PROPIEDAD DEL MENÚ DIGITAL
            </h2>
            <div className="space-y-4" data-id="element-8327">
              <p data-id="element-8328">El menú digital creado dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8329">
                <li data-id="element-8330">Pertenece al restaurante en términos de contenido</li>
                <li data-id="element-8331">
                  Puede ser utilizado por el restaurante fuera del marketplace
                </li>
              </ul>
              <p className="mt-4 font-medium text-white" data-id="element-8332">Condiciones:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/70" data-id="element-8333">
                <li data-id="element-8334">
                  Si el restaurante mantiene una suscripción activa, el sistema
                  opera normalmente
                </li>
                <li data-id="element-8335">
                  Si no mantiene suscripción:
                  <ul className="list-circle pl-6 mt-2 space-y-1" data-id="element-8336">
                    <li data-id="element-8337">
                      Podrá seguir utilizando el sistema únicamente si cubre
                      costos asociados (hosting, dominio, etc.)
                    </li>
                    <li data-id="element-8338">NOIZA podrá limitar funcionalidades</li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>

          <section data-id="element-8339">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8340">
              <span className="text-[#006847]" data-id="element-8341">8.</span>
              SISTEMA SaaS
            </h2>
            <div className="space-y-4" data-id="element-8342">
              <p data-id="element-8343">NOIZA proporciona un sistema tecnológico que incluye:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8344">
                <li data-id="element-8345">Menú digital</li>
                <li data-id="element-8346">Gestión de pedidos</li>
                <li data-id="element-8347">Herramientas operativas</li>
              </ul>
              <div className="grid sm:grid-cols-2 gap-6 mt-6" data-id="element-8348">
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8349">
                  <p className="font-medium text-white mb-2" data-id="element-8350">
                    El restaurante recibe:
                  </p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8351">
                    <li data-id="element-8352">Derecho de uso del sistema</li>
                  </ul>
                </div>
                <div className="bg-white/5 p-4 rounded-xl border border-white/10" data-id="element-8353">
                  <p className="font-medium text-white mb-2" data-id="element-8354">NO recibe:</p>
                  <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8355">
                    <li data-id="element-8356">Propiedad del software</li>
                    <li data-id="element-8357">Acceso al código fuente</li>
                  </ul>
                </div>
              </div>
              <p className="font-medium text-white mt-4" data-id="element-8358">
                NOIZA mantiene todos los derechos sobre la tecnología
                desarrollada.
              </p>
            </div>
          </section>

          <section data-id="element-8359">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8360">
              <span className="text-[#006847]" data-id="element-8361">9.</span>
              DISPONIBILIDAD DEL SERVICIO
            </h2>
            <div className="space-y-4" data-id="element-8362">
              <p data-id="element-8363">NOIZA no garantiza:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8364">
                <li data-id="element-8365">Disponibilidad continua</li>
                <li data-id="element-8366">Funcionamiento sin interrupciones</li>
                <li data-id="element-8367">Ausencia total de errores</li>
              </ul>
              <p className="mt-4" data-id="element-8368">Pueden ocurrir:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8369">
                <li data-id="element-8370">Fallas técnicas</li>
                <li data-id="element-8371">Actualizaciones</li>
                <li data-id="element-8372">Mantenimientos</li>
              </ul>
              <p className="font-medium text-white mt-2" data-id="element-8373">
                NOIZA no será responsable por pérdidas derivadas de estos
                eventos.
              </p>
            </div>
          </section>

          <section data-id="element-8374">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8375">
              <span className="text-[#006847]" data-id="element-8376">10.</span>
              VISIBILIDAD EN EL MARKETPLACE
            </h2>
            <div className="space-y-4" data-id="element-8377">
              <p data-id="element-8378">El restaurante acepta que su visibilidad dentro de NOIZA:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8379">
                <li data-id="element-8380">No está garantizada permanentemente</li>
                <li data-id="element-8381">Puede variar según criterios internos</li>
              </ul>
              <p className="mt-4" data-id="element-8382">NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8383">
                <li data-id="element-8384">Destacar o no restaurantes</li>
                <li data-id="element-8385">Modificar posiciones</li>
                <li data-id="element-8386">Aplicar filtros o algoritmos</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8387">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8388">
              <span className="text-[#006847]" data-id="element-8389">11.</span>
              PAGOS Y CONDICIONES ECONÓMICAS
            </h2>
            <div className="space-y-4" data-id="element-8390">
              <p data-id="element-8391">El restaurante se compromete a:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8392">
                <li data-id="element-8393">Cumplir con los pagos acordados</li>
                <li data-id="element-8394">Mantener su cuenta al día</li>
              </ul>
              <p className="mt-4" data-id="element-8395">En caso de incumplimiento, NOIZA podrá:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8396">
                <li data-id="element-8397">Suspender el servicio</li>
                <li data-id="element-8398">Limitar funcionalidades</li>
                <li data-id="element-8399">Retirar visibilidad</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8400">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8401">
              <span className="text-[#006847]" data-id="element-8402">12.</span>
              TERMINACIÓN
            </h2>
            <div className="space-y-4" data-id="element-8403">
              <p data-id="element-8404">NOIZA podrá suspender o terminar el acceso en caso de:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8405">
                <li data-id="element-8406">Incumplimiento de términos</li>
                <li data-id="element-8407">Uso indebido</li>
                <li data-id="element-8408">Conductas que afecten la plataforma</li>
              </ul>
              <p className="mt-2" data-id="element-8409">
                El restaurante podrá dejar de usar el servicio en cualquier
                momento.
              </p>
            </div>
          </section>

          <section data-id="element-8410">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8411">
              <span className="text-[#006847]" data-id="element-8412">13.</span>
              MODIFICACIONES
            </h2>
            <div className="space-y-4" data-id="element-8413">
              <p data-id="element-8414">NOIZA podrá modificar estos términos en cualquier momento.</p>
              <p data-id="element-8415">El uso continuo implica aceptación automática de cambios.</p>
            </div>
          </section>

          <section data-id="element-8416">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8417">
              <span className="text-[#006847]" data-id="element-8418">14.</span>
              LIMITACIÓN DE RESPONSABILIDAD
            </h2>
            <div className="space-y-4" data-id="element-8419">
              <p data-id="element-8420">En ningún caso NOIZA será responsable por:</p>
              <ul className="list-disc pl-6 space-y-1 text-white/70" data-id="element-8421">
                <li data-id="element-8422">Pérdidas económicas</li>
                <li data-id="element-8423">Daños indirectos</li>
                <li data-id="element-8424">Lucro cesante</li>
                <li data-id="element-8425">Daños reputacionales</li>
              </ul>
            </div>
          </section>

          <section data-id="element-8426">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8427">
              <span className="text-[#006847]" data-id="element-8428">15.</span>
              LEGISLACIÓN APLICABLE
            </h2>
            <div className="space-y-4" data-id="element-8429">
              <p data-id="element-8430">
                Estos términos se regirán por la legislación aplicable en Costa
                Rica.
              </p>
            </div>
          </section>

          <section className="bg-white/5 p-6 rounded-2xl border border-white/10 mt-12" data-id="element-8431">
            <h2 className="text-xl font-bold text-white mb-4 flex items-baseline gap-3" data-id="element-8432">
              <span className="text-[#006847]" data-id="element-8433">16.</span>
              ACEPTACIÓN FINAL
            </h2>
            <div className="space-y-4" data-id="element-8434">
              <p className="font-medium" data-id="element-8435">El restaurante declara que:</p>
              <ul className="list-disc pl-6 space-y-2 text-white/80" data-id="element-8436">
                <li data-id="element-8437">Ha leído este documento completo</li>
                <li data-id="element-8438">Comprende su alcance</li>
                <li data-id="element-8439">Acepta todas sus condiciones</li>
              </ul>
            </div>
          </section>
        </div>
      </main>
    </div>;
}